export default () => ({
  restrict: "A",
  link(scope, element, attrs) {
    const rememberMe = {};
    const map = scope.$eval(attrs.swapHover);
    element
      .on("mouseenter", function () {
        for (let key in map) {
          if (map[key]) {
            rememberMe[key] = element.attr(key);
            element.attr(key, map[key]);
          }
        }
      })
      .on("mouseout", function () {
        for (let key in rememberMe) {
          element.attr(key, rememberMe[key]);
        }
      });
  },
});
